/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Access_Denied_TitleInputs */

const en_auth_error_access_denied_title = /** @type {(inputs: Auth_Error_Access_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access denied`)
};

const fr_auth_error_access_denied_title = /** @type {(inputs: Auth_Error_Access_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès refusé`)
};

const ms_sg2_auth_error_access_denied_title = /** @type {(inputs: Auth_Error_Access_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses ditolak`)
};

/**
* | output |
* | --- |
* | "Access denied" |
*
* @param {Auth_Error_Access_Denied_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const auth_error_access_denied_title = /** @type {((inputs?: Auth_Error_Access_Denied_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Access_Denied_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_error_access_denied_title(inputs)
	if (locale === "fr") return fr_auth_error_access_denied_title(inputs)
	return ms_sg2_auth_error_access_denied_title(inputs)
});